import isExperienceEditor from "@utils/is-experience-editor";

(function () {
    if ($('[data-slider="mediaCard"]').length <= 0) {
        return;
    };

    var mediaCardSlider = function () {
        var ui = {};

        function cacheUI() {
            ui.$body = $('body');
            ui.$mediaCard = $('[data-slider="mediaCard"]');
        }

        function initMediaCardSlider(e) {
            ui.$mediaCard.each(function (index, element) {
                $(this).addClass('js-mediaCard-slider' + index);
                var item_length = $('.js-mediaCard-slider' + index + ' > div').length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-mediaCard-slider' + index).slick({
                        autoplay: false,
                        infinite: false,
                        arrows: true,
                        dots: false,
                        slidesToShow: 2.4,
                        slidesToScroll: 1,
                        prevArrow: $('.media-card__slider-controls__arrow-prev'),
                        nextArrow: $('.media-card__slider-controls__arrow-next'),
                        adaptiveHeight: false,
                        rows: 0, // Fix vor v1.8.0-1
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    arrows: true,
                                    dots: false,
                                }
                            },
                            {
                                breakpoint: 767,
                                settings:{
                                    slidesToShow: 1.1,
                                    slidesToScroll: 1,
                                    arrows: false,
                                    dots: true,
                                }
                            }
                        ]
                    });
                }
            });

            ui.$mediaCard.addClass('initialize');
        }

        function init() {
            cacheUI();
            initMediaCardSlider();
        }

        return {
            init: init
        };
    };

    var mediaCardSlider = mediaCardSlider();
    mediaCardSlider.init();
})(window);